import { useEffect, useState } from "react";
import UserContext from "./UserContext";
import {
  onAuthStateChanged,
  signInWithPopup,
  signOut,
  GoogleAuthProvider,
} from "firebase/auth";
import { auth } from "../firebase";
import authService from "../services/authService";

export const UserState = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loginError, setLoginError] = useState(false);

  useEffect(() => {
    return onAuthStateChanged(auth, async (firebaseUser) => {
      setLoading(true);
      if (!firebaseUser) {
        setUser(null);
        setLoading(false);
        return;
      }

      try {
        const response = await authService.getMe();
        setUser(response.data);
      } catch {
        setUser(null);
        await signOut(auth);
        setLoginError(true);
      } finally {
        setLoading(false);
      }
    });
  }, []);

  const Login = async () => {
    setLoginError(false);
    try {
      await signInWithPopup(auth, new GoogleAuthProvider());
    } catch (error) {
      console.error(error);
      setLoginError(true);
    }
  };

  const Logout = async () => {
    await signOut(auth);
  };

  return (
    <UserContext.Provider
      value={{
        user,
        loading,
        setLoading,
        loginError,
        Login,
        Logout,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
